import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import useTendering from "../../../hooks/useTendering";
import useQuotation from "../../../hooks/useQuotation";
import TenderingDetailContext from "../context";
import List, { STATE } from "../../../components/List";
import { format } from "date-fns";
import { formatNumber } from "../../../helpers/common.helper";
import SecondaryPagination from "../../../components/SecondaryPagination/SecondaryPagination";
import { ReactComponent as EveSvg } from "../../../assets/tendering/eye.svg";

const TaxInvoices = (props) => {
  const { details } = useContext(TenderingDetailContext);
  const {} = useTendering();
  const { queryQuotation } = useQuotation();
  const [datasource, setDatasource] = useState([]);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [metadata, setMetadata] = useState(undefined);
  const [fetchingState, setFetchingState] = useState(STATE.IDLE);

  useEffect(() => {
    // _refetch();
  }, []);

  const _refetch = (_limit, _page) => {
    let quotationIds = details.participants.find((p) => p.won === true)
      .quotation.submissions;

    queryQuotation(
      {
        _id: {
          $in: quotationIds,
        },
      },
      _page ?? page,
      _limit ?? limit
    ).then(({ data, _metadata }) => {
      setMetadata(_metadata);
      setDatasource(
        data.map((d) => ({
          _id: d._id,
          code: d.code,
          date: format(new Date(d.createdOn), "dd MMM yyyy"),
          remark: "",
          cost: formatNumber(d.grandTotal, "THB"),
          status: "active",
          actions: (
            <div className="tendering-documents__tax-invoices__list__actions">
              <div className="tendering-documents__tax-invoices__list__actions__action">
                <EveSvg />
              </div>
            </div>
          ),
        }))
      );
      setFetchingState(STATE.IDLE);
    });
  };

  return (
    <div className="tendering-documents__tax-invoices">
      <h2>Payment Terms</h2>
      <List
        contentState={fetchingState}
        scrollable={true}
        viewable={true}
        onRecordClick={(record) => {
          // TODO: Preview file
          console.log("record", record);
        }}
        columns={[
          {
            display: "Document No",
            key: "code",
            textAlign: "left",
            width: 150,
          },
          {
            display: "Date",
            key: "date",
            textAlign: "left",
            width: 100,
          },
          {
            display: "Remarks",
            key: "remark",
            textAlign: "left",
          },
          {
            display: "Cost",
            key: "cost",
            textAlign: "left",
            width: 200,
          },
          {
            display: "Status",
            key: "status",
            textAlign: "left",
          },
          //   {
          //     display: "",
          //     key: "actions",
          //     textAlign: "left",
          //   },
        ]}
        dataSource={datasource}
      >
        <SecondaryPagination
          defaultLimit={limit}
          limits={[1, 10, 50]}
          pages={metadata?.totalPages || 1}
          onPageChange={(page) => {
            setPage(page);
            setFetchingState(STATE.LOADING);
            _refetch(undefined, page);
          }}
          onLimitChange={(limit) => {
            setLimit(limit);
            setPage(1);
            setFetchingState(STATE.LOADING);
            _refetch(limit, 1);
          }}
        />
      </List>
    </div>
  );
};

TaxInvoices.propTypes = {};

export default TaxInvoices;
